import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MultiFileUploadComponent } from './multi-file-upload.component';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { DragDropModule } from '../../directives/drag-n-drop/drag-drop.module';

@NgModule({
  declarations: [MultiFileUploadComponent],
  exports: [MultiFileUploadComponent],
  imports: [CommonModule, MatProgressBarModule, DragDropModule],
})
export class MultiFileUploadModule {}
